import React from 'react'

const StudentManagement = () => {
  return (
    <div>
      studentManagement
    </div>
  )
}

export default StudentManagement
